import React, { useEffect, useRef, useState } from 'react';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import Box from '@mui/material/Box';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import { Onboarding } from 'components/Fleets';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { VehiclesGroupsActions } from 'state/modules/vehiclesGroups';

export const FleetsOnboarding = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const onboardingRef = useRef();
  const [showSaveAndExitBtn, setShowSaveAndExitBtn] = useState(false);

  /**
   * Handle save and exit event
   */
  const handleOnSaveAndExit = () => {
    if (onboardingRef.current) {
      onboardingRef.current.handleOnSaveAndExit();
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(VehiclesGroupsActions.fetchVehicleGroupById(id));
    }
  }, [id, dispatch]);

  return (
    <Layout title="Dashboard">
      <Container maxWidth="lg">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid size={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              style={{ marginBottom: 48 }}
            >
              <Grid>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
                    {i18n.t(`vehicle_groups.${!id ? 'new_service_area' : 'edit_service_area'}`)}
                  </Box>
                </Typography>
              </Grid>
              {showSaveAndExitBtn && (
                <Grid>
                  <Button onClick={handleOnSaveAndExit} variant="contained" color="primary">
                    {i18n.t('wizard.save_and_exit')}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid size={12}>
            <Onboarding
              forwardRef={onboardingRef}
              onSave={setShowSaveAndExitBtn}
              mode={id ? 'edit' : 'create'}
            />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};
